import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/flags/usa.svg'
import _imports_1 from '@/assets/images/flags/israel.svg'
import _imports_2 from '@/assets/images/flags/brazil.svg'


const _hoisted_1 = { class: "block text-black dark:text-white font-semibold px-[20px] pb-[14px] text-sm md:text-[15px]" }
const _hoisted_2 = { class: "border-t border-dashed border-gray-100 dark:border-[#172036]" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "ml-2 text-green-500"
}
const _hoisted_6 = { class: "border-t border-dashed border-gray-100 dark:border-[#172036]" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = {
  key: 0,
  class: "ml-2 text-green-500"
}
const _hoisted_10 = { class: "border-t border-dashed border-gray-100 dark:border-[#172036]" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "ml-2 text-green-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative language-menu mx-[8px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
  }, {
    default: _withCtx(({ close }) => [
      _createVNode(_component_MenuButton, { class: "leading-none pr-[12px] inline-block transition-all relative top-[2px] hover:text-primary-500" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] md:!text-[22px]" }, " translate ", -1),
          _createElementVNode("i", { class: "ri-arrow-down-s-line text-[15px] absolute -right-[3px] top-1/2 -translate-y-1/2 -mt-[2px]" }, null, -1)
        ])),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuItems, { class: "bg-white dark:bg-[#0c1427] transition-all shadow-3xl dark:shadow-none pt-[13px] md:pt-[14px] absolute mt-[18px] md:mt-[21px] w-[200px] md:w-[240px] z-[1] top-full ltr:left-0 ltr:md:left-auto ltr:lg:right-0 rtl:right-0 rtl:md:right-auto rtl:lg:left-0 rounded-md focus:outline-hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.directT('common.chooseLanguage')), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-black dark:text-white px-[20px] py-[12px] d-block w-full font-medium", { 'bg-gray-50 dark:bg-[#172036]': _ctx.currentLanguage === 'en' }]),
                    onClick: ($event: any) => {_ctx.changeLanguage('en'); close()}
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[1] || (_cache[1] = _createElementVNode("img", {
                        src: _imports_0,
                        class: "w-[30px] ltr:mr-[10px] rtl:ml-[10px]",
                        alt: "usa"
                      }, null, -1)),
                      _cache[2] || (_cache[2] = _createTextVNode(" English ")),
                      (_ctx.currentLanguage === 'en')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "✓"))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_3)
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-black dark:text-white px-[20px] py-[12px] d-block w-full font-medium", { 'bg-gray-50 dark:bg-[#172036]': _ctx.currentLanguage === 'he' }]),
                    onClick: ($event: any) => {_ctx.changeLanguage('he'); close()}
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        src: _imports_1,
                        class: "w-[30px] ltr:mr-[10px] rtl:ml-[10px]",
                        alt: "israel"
                      }, null, -1)),
                      _cache[4] || (_cache[4] = _createTextVNode(" Hebrew (עברית) ")),
                      (_ctx.currentLanguage === 'he')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "✓"))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_7)
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-black dark:text-white px-[20px] py-[12px] d-block w-full font-medium", { 'bg-gray-50 dark:bg-[#172036]': _ctx.currentLanguage === 'ar' }]),
                    onClick: ($event: any) => {_ctx.changeLanguage('ar'); close()}
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: _imports_2,
                        class: "w-[30px] ltr:mr-[10px] rtl:ml-[10px]",
                        alt: "arabic"
                      }, null, -1)),
                      _cache[6] || (_cache[6] = _createTextVNode(" Arabic (العربية) ")),
                      (_ctx.currentLanguage === 'ar')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "✓"))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_11)
                ])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}